import React from "react";
import { BsFacebook, BsTwitter, BsYoutube } from "react-icons/bs";
import { AiFillInstagram } from "react-icons/ai";
import { Link } from "react-router-dom";
import { logo_light } from "../Web3/web3_api";
import "./Footer.css";

const socials = [
  { href: "https://www.facebook.com/pansea.io", Icon: BsFacebook, label: "Facebook" },
  { href: "https://twitter.com/panseaio", Icon: BsTwitter, label: "Twitter" },
  { href: "https://www.instagram.com/panseaio/", Icon: AiFillInstagram, label: "Instagram" },
  { href: "https://www.youtube.com/@panseaio", Icon: BsYoutube, label: "YouTube" },
];

function Footer() {
  return (
    <footer className="w3-footer">
      <div className="w3-container">
        <div className="w3-footer-grid">
          <div className="w3-footer-brand">
            <img src={logo_light()} alt="PanSea" />
            <p>
              The world’s first and largest digital marketplace for crypto
              collectibles and non-fungible tokens (NFTs). Buy, sell, and
              discover exclusive digital items.
            </p>
            <div className="w3-socials">
              {socials.map(({ href, Icon, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
                  <Icon />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h5>Marketplace</h5>
            <ul>
              {["Art", "Gaming", "Membership", "Metaverse", "Utility"].map((c) => (
                <li key={c}><a href={`/categories/${c}`}>{c}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h5>My Profile</h5>
            <ul>
              <li><a href="/createnft">Create</a></li>
              <li><a href="/mycollections">My Collection</a></li>
              <li><a href="/profilesetting">Settings</a></li>
            </ul>
          </div>
          <div>
            <h5>Resources</h5>
            <ul>
              <li><a href="/help">Help</a></li>
            </ul>
          </div>
        </div>
        <div className="w3-footer-bottom">
          <span>© {new Date().getFullYear()} PanSea Inc</span>
          <span>
            <Link to="/privacy">Privacy Policy</Link> &nbsp;·&nbsp;{" "}
            <Link to="/terms">Terms of Service</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
